import React, { useState, useEffect, useContext, useCallback } from "react";
import { withRouter } from "react-router-dom";
import {
  Typography,
  Button,
  Dropdown,
  Tooltip,
  Input,
  Menu,
  Icon,
  message,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { platformApi } from "../../../api";
import { ContextAPI } from "../../../ContextAPI";
import NotificationsTable from "./NotificationsTable";
import { ensureTelecmiThenCloudCall } from "../../../utils/notificationCloudCall";
import "./index.less";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

const Notifications = (props) => {
  const { loginCredintials } = useContext(ContextAPI);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [spinning, setSpinning] = useState(false);
  const [dataSource, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0);
  const [search, setSearch] = useState(null);
  const [readAccess, setReadAccess] = useState(false);

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu);
          setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (
          String(each.subModule || "").toLowerCase() === "notifications" &&
          each.access?.read
        ) {
          setReadAccess(true);
        }
      });
  }, [loginCredintials]);

  const setPrimaryData = useCallback(() => {
    if (!readAccess) return;
    setSpinning(true);
    platformApi
      .get("/api/notifications", {
        params: { page, size: limit },
      })
      .then((result) => {
        setSpinning(false);
        const { data } = result;
        if (data.code === 200) {
          let rows = data.data?.notifications || [];
          if (search) {
            const q = String(search).toLowerCase();
            rows = rows.filter(
              (n) =>
                (n.title || "").toLowerCase().includes(q) ||
                (n.body || "").toLowerCase().includes(q) ||
                (n.purpose || "").toLowerCase().includes(q)
            );
          }
          setData(rows);
          setCount(search ? rows.length : data.data?.count || 0);
          setUnreadCount(data.data?.unreadCount || 0);
        } else {
          message.error("Unable to fetch notifications", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Notifications:", error);
        message.error("Unable to fetch notifications", 2);
        setSpinning(false);
      });
  }, [page, limit, search, readAccess]);

  useEffect(() => {
    setPrimaryData();
  }, [setPrimaryData]);

  const markRead = (id) => {
    platformApi
      .post(`/api/notifications/${id}/read`)
      .then((res) => {
        if (res.data?.code === 200) {
          message.success("Marked as read", 1);
          setPrimaryData();
        } else {
          message.error("Unable to mark as read", 2);
        }
      })
      .catch(() => message.error("Unable to mark as read", 2));
  };

  const handleCall = async (record) => {
    const result = await ensureTelecmiThenCloudCall({
      notification: record,
      employeeName: loginCredintials?.employeeName,
      markRead: true,
    });
    if (result.ok) setPrimaryData();
  };

  const markAllRead = () => {
    const unread = dataSource.filter((n) => !n.isRead);
    if (!unread.length) {
      message.info("No unread notifications");
      return;
    }
    setSpinning(true);
    Promise.all(
      unread.map((n) => platformApi.post(`/api/notifications/${n.id}/read`))
    )
      .then(() => {
        message.success("All marked as read", 2);
        setPrimaryData();
      })
      .catch(() => {
        message.error("Unable to mark all as read", 2);
        setSpinning(false);
      });
  };

  if (!readAccess) {
    return (
      <div style={{ padding: 24 }}>
        <Title level={4}>Access Denied</Title>
        <p>You do not have Notifications module access.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "55%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => props.history.goBack()}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          Notification [{count}]
          {unreadCount > 0 && (
            <span style={{ marginLeft: 8, fontSize: 14, fontWeight: 400 }}>
              ({unreadCount} unread)
            </span>
          )}
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit}
                &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "25%" }}
          placeholder="Search Notifications"
          onSearch={(event) => {
            setPage(1);
            setSearch(event || null);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null);
              setPage(1);
            }
          }}
        />
        <Button
          onClick={markAllRead}
          style={{ margin: "0 3%", width: "18%" }}
          type="primary"
          disabled={!unreadCount}
        >
          Mark All as Read
        </Button>
      </div>
      <NotificationsTable
        pagination={{
          onChange: (p) => setPage(p),
          pageSize: limit,
          defaultCurrent: 1,
          current: page,
          total: count,
          showQuickJumper: true,
        }}
        dataSource={dataSource}
        spinner={{ spinning }}
        onMarkRead={markRead}
        onCall={handleCall}
      />
    </div>
  );
};

export default withRouter(Notifications);
